import { SortDirection } from "@bridgesplit/utils";

export type TimeLockFilter = {
    vaultAddresses?: string[];
    timelockStatus?: TimeLockStatus;
    page: number;
    pageSize: number;
    sortDirection?: SortDirection;
    includeInstant: boolean;
};

export enum TimeLockStatus {
    Pending = 0,
    Executed = 1,
    Cancelled = 2
}
